/**
 * @file app提示升级弹窗
 */
import { Button } from '@bfe/moly';
import { Modal } from '../modal';

import styles from './index.module.scss';

export interface Props {
  show: boolean;
  onClose: () => void;
  text: string;
  buttonText: string;
}

export const AppVersionModal = (props: Props) => {
  const { show, onClose, text, buttonText } = props;

  return (
    <Modal
      type="alert"
      onCancel={() => {
        onClose();
      }}
      open={show}
      footer={null}
    >
      <div className={styles.desc}>{text}</div>
      <div className={styles.action}>
        <Button
          variant="primary"
          className={styles.button}
          onClick={() => {
            onClose();
          }}
        >
          {buttonText}
        </Button>
      </div>
    </Modal>
  );
};
